/**
 * Created by vetal on 15.11.16.
 */
define('plugin/telegram-notifications/TelegramNotificationsPlugin',['require','lib/plugin/PluginAbstract','lib/AppRouter','plugin/telegram-notifications/model/TelegramNotificationsModel','plugin/telegram-notifications/view/TelegramNotificationsView','lib/theme/ThemeSettings','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AppRouter = require('lib/AppRouter');
    var TelegramNotificationsModel = require('plugin/telegram-notifications/model/TelegramNotificationsModel');

    var TelegramNotificationsView = require('plugin/telegram-notifications/view/TelegramNotificationsView');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');

    return PluginAbstract.extend({

        _collection : null,
        _moduleView: null,
        _telegramNotificationsModel: null,
        _clientModel: null,

        _telegramNotifModuleRegions: {
            telegramNotificationsBooking: '#sb_telegram_notification_container',
        },

        initialize: function () {
            this._telegramNotificationsModel = new TelegramNotificationsModel();
            var config = Config.getInstance();

            //console.log(121212);
            this._clientModel = this.getOption('clientModel');

            Backbone.Wreqr.radio.channel('page').vent.on(
                'render', _.bind(this._addToClientView, this)
            );
        },

        _initNotifications : function (){
        },


        _addToClientView: function (data) {
            var _this = this;

            var isLogged = this._clientModel.get('is_logged_in');

            //console.log(data.page, data.page == 'client_profile', isLogged);

            if (data.page == 'client_profile' && isLogged) {
                _this._getTelegramNotificationsView(function (pushView) {
                   // _this._addView(pushView, data.view);
                });
            }
        },

        _addView: function (view, layout) {

            console.log(layout, view);
            if (!layout.telegram_notifications) {
                layout.addRegion('telegram_notifications', {
                    'selector': '.sb-telegram-notifications',
                    'allowMissingEl': true
                });
            }
            layout.showChildView('telegram_notifications', view);
        },

        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();

            //this.listenTo(this._stepManager.getBookingModel(), 'change:start_date',  this._setPwaDevice);
        },

        /**
         * On show client bookings page.
         * If we got cart_id we will load cart status from server
         *
         * @param BookingResultView view
         * @param Object data
         */
        onShowClientBookings: function (view, data) {
            // this._redirectHome();
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         */
        onFinishPayment: function (view, data) {

        },

        /**
         * On finish booking
         *
         * @param view
         * @param data
         */
        onFinishBooking: function (data) {

        },

        _getTelegramNotificationsView: function (handler) {
            //console.log(1212122222);
            var _this = this;
            if(_this._moduleView){
                handler(_this._moduleView);
            }

            if(_this._moduleViewC){
                return ;
            }

            _this._moduleViewC = true;

            new Promise(function(resolve, reject) {
                _this._telegramNotificationsModel.on('sync', function () {
                    resolve(true);
                }).fetch();

            }).then(function() {
                _this._moduleView = new TelegramNotificationsView({
                    clientModel: _this._clientModel,
                    model: _this._telegramNotificationsModel,
                });

                handler(_this._moduleView);
            });

        },

        initModules: function (view) {
            var _this = this;

            _.each(this._telegramNotifModuleRegions, function (selector, telegramNotifModuleRegion) {
                view.addRegion(telegramNotifModuleRegion, selector);
            });

            if(Config.getInstance().getPluginStatus('telegram_notifications')) {
                if (view.telegramNotificationsBooking.$el.length) {
                    _this._getTelegramNotificationsView(function (pushView) {
                        view.telegramNotificationsBooking.show(pushView);
                    });
                }
            }
        },

        _redirectWithReplace: function (path, options) {
            if (_.isUndefined(options)) {
                options = {
                    trigger: true,
                    replace: true
                };
            }
            Backbone.history.navigate(path, options);
        },
        
        
    });

});
